
import * as Yup from "yup";
import useLocale from "@/core/common/useLocale";
import { nextTick, onMounted, ref } from "vue";
import { useStore } from "vuex";
import { PasswordMeterComponent } from "@/assets/ts/components";
import { reinitializeComponents } from "@/core/plugins/keenthemes";
import { ErrorMessage, Field, Form } from "vee-validate";

export default {
  name: "QuestionnaireSignUp",
  components: { ErrorMessage, Field, Form },
  emits: ["submitForm"],

  setup(props, { emit }) {
    const { t } = useLocale();
    const store = useStore();

    const userEmail = ref(store.getters.userEmail);
    const userPassword = ref();
    const isPasswordHidden = ref(true);
    const isConfirmationPasswordHidden = ref(true);
    const disableUserInputEmail = ref(false);

    const togglePassword = function (type) {
      if (type === "password") {
        isPasswordHidden.value = !isPasswordHidden.value;
      } else if (type === "confirmation_password") {
        isConfirmationPasswordHidden.value =
          !isConfirmationPasswordHidden.value;
      }
    };

    const registrationSchema = Yup.object().shape({
      email: Yup.string()
        .min(4)
        .required(t("Email is a required field"))
        .email(t("emailValidation"))
        .label(t("Email")),
      password: Yup.string()
        .matches(/[1-9]+/, t("Use number"))
        .matches(/[a-z]+/, t("Use lowercase character"))
        .matches(/[A-Z]+/, t("Use uppercase character"))
        .matches(
          /[!"#$%&'()*+,-./:;<=>?@[\]^_'{|}~]+/,
          t("Use special character")
        )
        .min(12, t("Password must be at least 12 characters"))
        .required(t("Password is a required field"))
        .label(t("Password")),
      password_confirmation: Yup.string()
        .required(t("Password is a required field"))
        .oneOf(
          [Yup.ref("password"), null],
          t("The password and its confirm are not the same")
        )
        .label(t("Password Confirmation")),
    });

    function onSubmit(values) {
      emit("submitForm", values);
    }

    onMounted(() => {
      nextTick(() => {
        PasswordMeterComponent.bootstrap();

        nextTick(() => {
          reinitializeComponents();
        });
      });

      if (userEmail.value) {
        disableUserInputEmail.value = true;
      }
    });

    return {
      userEmail,
      userPassword,
      isPasswordHidden,
      isConfirmationPasswordHidden,
      registrationSchema,
      disableUserInputEmail,
      togglePassword,
      onSubmit,
    };
  },
};
